import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { QueryExecution } from '../../types';
import { Column, ColumnKeys, DEFAULT_PAGE_SIZE, LiveSearchResultsGridViewData } from '../types';
import { ViewConfiguration, ViewType } from '../../../../grid/gridView/types';
import { ColumnDetails, ColumnType } from '../../../../grid/types/common';

export default class LiveSearchResultsGridViewDataProvider extends BaseWebComponentDataProvider {
  public getDataForView(queryExecution: QueryExecution | null): LiveSearchResultsGridViewData {
    const view: ViewConfiguration<any, any> = this.getView(queryExecution);

    return {
      views: [view],
      allColumns: this.getAllColumns(queryExecution),
      defaultViewProps: view,
      queryExecution,
    };
  }

  private getView(queryExecution: QueryExecution | null): ViewConfiguration<any, any> {
    const displayedColumns: number[] = [Column.ENDPOINT];

    if (queryExecution && queryExecution.resultsFields) {
      for (let columnIndex = 1; columnIndex <= Object.keys(queryExecution.resultsFields).length; columnIndex++) {
        displayedColumns.push(columnIndex);
      }
    }

    return {
      id: 'live-search-grid',
      name: this.dependencies.translateFn('Default view'),
      type: ViewType.DEFAULT,
      filters: [],
      displayedColumns: displayedColumns,
      pageSize: DEFAULT_PAGE_SIZE,
      compactView: true,
    };
  }

  private getAllColumns(queryExecution: QueryExecution | null): Array<ColumnDetails<any, any>> {
    const defaultColumns: ColumnDetails<any, any>[] = [
      {
        column: Column.ENDPOINT,
        key: ColumnKeys.ENDPOINT,
        columnName: this.dependencies.translateFn('Endpoint'),
        type: ColumnType.STRING,
        removable: false,
      },
    ];
    let columnIndex = 1;

    return queryExecution && queryExecution.resultsFields
      ? defaultColumns.concat(
          Object.keys(queryExecution.resultsFields).map(
            (field: string): ColumnDetails<any, any> => ({
              column: columnIndex++,
              key: field,
              columnName: field,
              type: ColumnType.STRING,
              removable: false,
            })
          )
        )
      : defaultColumns;
  }
}
